/**
 * Utility function to normalise whitespace in text strings
 *
 * This function addresses layout issues caused by excessive whitespace
 * in text, particularly multiple consecutive spaces that can
 * break CSS layout calculations.
 *
 * @param {string} text - Text that may contain excessive whitespace
 * @returns {string} - Text with normalized whitespace
 */
export const normaliseWhitespace = text => {
  if (!text || typeof text !== 'string') return text

  // Replace multiple consecutive whitespace characters (spaces, tabs, newlines)
  // with a single space, then trim leading/trailing whitespace
  return text.replace(/\s+/g, ' ').trim()
}

export default normaliseWhitespace
